const settings = CONFIG;
export default settings;
